import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'wxQRCodeScan',
    },
  },
  {
    name: 'wxQRCodeScan',
    path: '/wxQRCodeScan',
    component: () => import('./view/wechat/qrcode/scan'),
    meta: {
      title: '微信扫一扫',
    },
  },
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export { router };
